
import React from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import Text from '../../common/client/components/Text';

import ObjectInfoTitle from './ObjectInfoTitle';

const classNames = mergeStyleSets({
    list: {
        overflowY: 'auto',
        maxHeight: 250
    },
    categoryTitle: {
        width: 150
    },
    itemTitle: {
        width: 150
    }
});

const ObjectInfoCategoryItem = (props) => {
    return (
        <Stack horizontal>
            <Stack.Item className={classNames.categoryTitle}>
                <Text>{props.item.title}</Text>
            </Stack.Item>
            <Stack.Item className={classNames.itemTitle}>
                <Text bold>{props.item.item_title}</Text>
            </Stack.Item>
        </Stack>
    );
}

const ObjectInfoCategory = (props) => {
    return (props.category.length > 0)
        ? <div>
            <ObjectInfoTitle title="Kategorie" />
            <div className={classNames.list}>
                {props.category.map(item => {
                    return (
                        <ObjectInfoCategoryItem key={item.gid} item={item} />
                    )
                })}
            </div>
        </div>
        : null;
}

export default ObjectInfoCategory;
